import { ChannelConfig } from "./ChannelConfig"
import { Vector3 } from 'three/src/math/Vector3'

const melodieChannel: ChannelConfig = {
    showInChannelList: true,
    passwordProtected: false,
    id: "melodie",
    
    tickerSeparator: "by",
    streamURL: "https://memustream.live:8443/melodiestream",
    streamURLDev: "https://memustream.live:8443/melodiestream",
    metadataURL: "https://memustream.live/memu/melodie/melodie_ticker.json",

    name: "Melodie",
    channelListName: "Melodie",
    urlSlug: "melodie",
    attributionDescription: "Making fresh tracks from the Melodie library.",
    
    attributionLogoSVGURL:  "/channel-logos/melodie.svg",
    attributionLogoIMGURL:  "/channel-logos/melodie.svg",  
    logoAspectRatio: 2.0752780154, // Width / Length
    colorsGradient2: [
      // Purple: RGB(128, 0, 128) → normalized (0.502, 0.0, 0.502)
      new Vector3(128/255, 0/255, 128/255),
    
      // Green: RGB(0, 255, 0) → normalized (0.0, 1.0, 0.0)
      new Vector3(0/255, 255/255, 0/255)
    ]
}

export default melodieChannel